import { useEffect } from 'react';

/**
 * Sets document.title and the meta description for a marketing page.
 * RouteTracker reads document.title one tick after the route change,
 * so setting it in a mount effect keeps GA page_view titles correct.
 */
export function usePageMeta(title: string, description?: string): void {
  useEffect(() => {
    document.title = title;
    if (description) {
      const el = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (el) el.content = description;
    }
  }, [title, description]);
}
